import axios from 'axios'
import store from '../store/store'

export function getAxiosInstance() {
  return axios.create({headers: {'Authorization': 'Bearer ' + store.state.apiKey}})
}

export function myaxios(request) {
  console.log(store.state.apiKey)
  const updatedRequest = request
  if (!updatedRequest.headers) {
    updatedRequest.headers = {}
  }
  if (!updatedRequest.headers.Authorization && store.state.apiKey) {
    updatedRequest.headers.Authorization = 'Bearer ' + store.state.apiKey
  }
  return axios(updatedRequest)
}



// WEBPACK FOOTER //
// ./src/helpers/axios-helper.js